import { Box, Inline, xcss } from '@atlaskit/primitives';
import { useLocale } from '@databases/intl';
import { toDisplayDate } from '@databases/utils/database/field-types/date';
import React, { type FunctionComponent } from 'react';

const dateValueContainer = xcss({
  backgroundColor: 'color.background.neutral',
  borderRadius: 'radius.small',
  color: 'color.text',
  paddingInline: 'space.050'
});

interface DateRangeProps {
  startDate: string;
  endDate: string;
}

export const DateRange: FunctionComponent<DateRangeProps> = ({ startDate, endDate }) => {
  const locale = useLocale();

  const start = toDisplayDate(startDate, locale);
  const end = toDisplayDate(endDate, locale);
  const isSameDate = startDate === endDate;

  return (
    <Inline alignBlock="center" shouldWrap space="space.050">
      {start && <Box xcss={dateValueContainer}>{start}</Box>}

      {start &&
        end &&
        !isSameDate &&
        // Won't translate -
        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        '-'}
      {end && !isSameDate && <Box xcss={dateValueContainer}>{end}</Box>}
    </Inline>
  );
};
